import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { BaseBean } from "../ds/client_ds.js";
import {
  FabricStyleSearchCriteria,
  PageListBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
  ProgressBar,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { ConfigManager } from "../config/ConfigManager.js";
export class PurchaseOrderReceiptLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, purchaseOrder,vendorCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.purchaseOrderNumber = purchaseOrder;
      this.vendorCode = vendorCode;
    this.state = {
      purchaseOrderLookupHandler: new PurchaseOrderLookupHandler(),
    };
    let resetCriteria = new PurchaseOrderReceiptSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new PurchaseOrderReceiptSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let purchaseOrderReceiptLookupCriteria =
      new PurchaseOrderReceiptSearchCriteria();
    purchaseOrderReceiptLookupCriteria.companyCode = this.companyCode;
    purchaseOrderReceiptLookupCriteria.purchaseOrderNumber =
      this.purchaseOrderNumber;
       purchaseOrderReceiptLookupCriteria.vendorCode =
      this.vendorCode;
    let lookupCriteriaView = PurchaseOrderReceiptLookupCriteraHandler(
      companyCode,
      purchaseOrderReceiptLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      purchaseOrderReceiptLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getPurchaseOrderReceiptStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Purchase Order", "purchaseOrderNumber", 0, false); //2
    this.addColumnDefinition("Vendor", "vendorCode", 0, false); //2
    this.addColumnDefinition("VendorName", "vendorName", 0, false); //2
    this.addColumnDefinition("ReceiptDate", "receiptDate", 0, false); //2
    this.addColumnDefinition("Receipt Status", "receiptStatus", 0, false); //2
    this.addColumnDefinition("ShipmentTerm", "shipmentTermsCode", 0, false); //2
    this.addColumnDefinition("Location", "locationCode", 0, false); //2
  }
  loadPurchaseOrderReceiptList = (
    lookup_dialog,
    pageNumber,
    searchCriteria
  ) => {
    let poReceipt_criteria = new PurchaseOrderReceiptSearchCriteria(); //To be fetched from CriteriaHandler
    poReceipt_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      poReceipt_criteria.purchaseOrderReceiptNumberStartsWith =
        searchCriteria.purchaseOrderReceiptNumberStartsWith;
      poReceipt_criteria.purchaseOrderReceiptNumberContains =
        searchCriteria.purchaseOrderReceiptNumberContains;
      poReceipt_criteria.purchaseOrderReceiptNumber =
        searchCriteria.purchaseOrderReceiptNumber;
      // poReceipt_criteria.purchaseOrderNumber =
      //   searchCriteria.purchaseOrderNumber;

      if (!isEmptyString(this.purchaseOrderNumber)) {
        poReceipt_criteria.purchaseOrderNumber = this.purchaseOrderNumber;
      } else {
        poReceipt_criteria.purchaseOrderNumber =
          searchCriteria.purchaseOrderNumber;
      }
      poReceipt_criteria.receiptStatus = searchCriteria.receiptStatus;
      if (!isEmptyString(this.vendorCode)) {
        poReceipt_criteria.vendorCode = this.vendorCode;
      } else {
        poReceipt_criteria.vendorCode = searchCriteria.vendorCode;
      }

   
      poReceipt_criteria.createdDate = searchCriteria.createdDate;
      poReceipt_criteria.receiptDateFrom = searchCriteria.receiptDateFrom;
      poReceipt_criteria.receiptDateTo = searchCriteria.receiptDateTo;
      poReceipt_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      poReceipt_criteria.fabricStyleColorCode =
        searchCriteria.fabricStyleColorCode;
    }
    let po_pageList = new PageListBean();
    po_pageList.pageSize = 50; //TODO --> Fetch from Config
    po_pageList.pageNumber = pageNumber;
    po_pageList.currentPage = pageNumber;
    let poReceipt_requestInput = new RestPurchaseOrderReceiptListRequest();
    poReceipt_requestInput.searchCriteria = poReceipt_criteria;
    poReceipt_requestInput.pageInput = po_pageList;
    PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
      poReceipt_requestInput,
      (response) =>
        this.loadPurchaseOrderReceiptListResponse(response, lookup_dialog),
      this.loadPurchaseOrderReceiptListError
    );
  };
  loadPurchaseOrderReceiptListResponse = (response, lookup_dialog) => {
    let poList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.purchaseOrderReceiptPageList != null &&
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts !== null
    ) {
      poList = response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
      totalCount = response.data.purchaseOrderReceiptPageList.totalCount;
      currentPageNumber =
        response.data.purchaseOrderReceiptPageList.currentPage;
      pageSize = response.data.purchaseOrderReceiptPageList.pageSize;
      poList.map((pl) => {
        pl.receiptStatus = ModuleUtils.getPurchaseOrderReceiptStatusCaption(
          pl.receiptStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = poList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };

  loadPurchaseOrderReceiptListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.purchaseOrderReceiptNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.purchaseOrderReceiptNumberContains = filterText;
        this.searchCriteria = new PurchaseOrderReceiptSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadPurchaseOrderReceiptList(lookup_dialog, pageNumber, search);
    }
  }
}
const PurchaseOrderReceiptLookupCriteraHandler = (
  companyCode,
  purchaseOrderReceiptLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PurchaseOrderReceiptSearchCriteria(),
        showAutoCompleteFabricList: true,
        fabricPageListForAutoCompleteList: new Array(),
        isShowColorLookup: false,
        colorLookupHandler: null,
        is3PL: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      searchCriteria.purchaseOrderNumber = this.purchaseOrderNumber;
          searchCriteria.vendorCode = this.vendorCode;
      this.setState({ searchCriteria: searchCriteria });
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let vendorLookupHandler = new VendorLookupHandler(companyCode, "Vendor");
      this.setState({ vendorLookupHandler: vendorLookupHandler });

      let purchaseLookupHandler = new PurchaseOrderLookupHandler(
        companyCode,
        "Purchase Order"
      );
      this.setState({ purchaseLookupHandler: purchaseLookupHandler });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        this.state.is3PL ? "Item" : "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new PurchaseOrderReceiptSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({
        searchCriteria: searchCriteria,
        isShowColorLookup: false,
        colorLookupHandler: null,
      });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    fabricCodeOnChange = (e) => {
      let fabricStyleCode = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(fabricStyleCode)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.fabricStyleCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleCode" &&
        showAutoCompleteList === true &&
        fabricStyleCode !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    // fabricStyleSelected = (data) => {
    //   let colors = data.colors;
    //   let colorList = [];
    //   colors.map((ent) => {
    //     let colorBean = new BaseBean();
    //     colorBean.code = ent.fabricStyleColorCode;
    //     colorBean.description = ent.fabricStyleColorName;
    //     colorList.push(colorBean);
    //   });
    //   this.setState({
    //     isShowColorLookup: true,
    //   });
    //   if (!isEmptyArray(colorList)) {
    //     let colorLookupHandler = new GenericAttributeLookupHandler(
    //       colorList,
    //       "Color"
    //     );
    //     this.setState({
    //       colorLookupHandler: colorLookupHandler,
    //     });
    //   }
    // };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.fabricStyleCode = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
          //   this.fabricStyleSelected(fabricStyle);
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      //input.isLoadChildren = true;
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading...",
      });
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    vendorCodeOnChange = (e) => {
      let vendorCode = e.target.value;
      this.state.showAutoCompleteVendorList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      if (isEmpty(vendorCode)) {
        this.state.showAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorList;
        let criteria = this.state.searchCriteria;
        criteria.vendorCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          vendorPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "vendorCode" &&
        showAutoCompleteList === true &&
        vendorCode !== ""
      ) {
        this.readVendorBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetVendorDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      if (response.data != null && response.data.vendor != null) {
        let vendorData = response.data.vendor;
        if (!isEmpty(vendorData)) {
          criteria.vendorCode = vendorData.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetVendorDetail = (vendorCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = vendorCode;
      //   input.isLoadChildren = true;
      VendorService.readVendor(
        input,
        this.readandsetVendorDetailResponse,
        this.errorCallBack
      );
    };
    readVendorBySearchString(searchString) {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;

      searchCriteria.vendorCodeStartsWith = searchString;
      searchCriteria.vendorNameContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestVendorListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.errorCallBack
      );
    }
    readByVendorCodeResponse = (response) => {
      if (
        response.data != null &&
        response.data.vendorPageList != null &&
        response.data.vendorPageList.vendors != null
      ) {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
          vendorCodeData.map((vendorCode) => {
            let simpleItemBean = {
              code: vendorCode.code,
              description: vendorCode.description,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    vendorCodeEnterKeyEventHandler = (e) => {
      let vendorCode = e.target.value;
      this.readandsetVendorDetail(vendorCode);
      this.setState({
        vendorPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteVendorList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
    };

    errorCallBack = (error) => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      ShowError(error);
    };

    onPurchaseOrderChange = (e) => {
      let purchaseOrderNumber = e.target.value;
      this.state.showAutoCompletePurchaseOrderList = true;
      let criteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompletePurchaseOrderList;
      if (isEmpty(purchaseOrderNumber)) {
        this.state.showAutoCompletePurchaseOrderList = false;
        let showAutoCompleteList = this.state.showAutoCompletePurchaseOrderList;
        let criteria = this.state.searchCriteria;
        criteria.purchaseOrderNumber = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          purchaseOrderPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "purchaseOrderNumber" &&
        showAutoCompleteList === true &&
        purchaseOrderNumber !== ""
      ) {
        this.readPurchaseOrderBySearchString(e.target.value);
      }
      criteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: criteria });
    };
    readPurchaseOrderBySearchString(searchString) {
      let searchCriteria = new PurchaseOrderSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.purchaseOrderNumberStartsWith = searchString;
      searchCriteria.purchaseOrderNumberContains = searchString;
      let cust_pageList = new PageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestPurchaseOrderListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      PurchaseOrderService.getPurchaseOrderPageList(
        cust_requestInput,
        this.readPurchaseOrderBySearchStringResponse,
        this.errorCallBack
      );
    }
    readPurchaseOrderBySearchStringResponse = (response) => {
      let purchaseorderData =
        response.data.purchaseOrderPageList.purchaseOrders;
      let simpleAutoCompleteList = new Array();
      if (response.data.purchaseOrderPageList != null) {
        if (purchaseorderData.length > 0 && purchaseorderData != null) {
          purchaseorderData.map((po) => {
            let simpleItemBean = {
              code: po.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
      }
      this.setState({
        purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    purchaseOrderEnterKeyEventHandler = (e) => {
      let poCode = e.target.value;
      this.readPurchaseOrder(poCode);
      this.setState({
        purchaseOrderPageListForAutoCompleteList: new Array(),
      });
    };
    readPurchaseOrder = (purchaseOrderCode) => {
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = companyCode;
      readrestInput.code = purchaseOrderCode;
      PurchaseOrderService.readPurchaseOrder(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.errorCallBack
      );
    };
    readPurchaseOrderResponse = (response) => {
      if (response.data != null && response.data != null) {
        if (!isEmptyArray(response.data.purchaseOrder)) {
          let poBean = response.data.purchaseOrder;
          let criteria = this.state.searchCriteria;
          criteria.purchaseOrderNumber = poBean.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompletePurchaseOrderList: showAutoCompleteList,
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <ProgressBar
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Purchase Receipt Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderReceiptNumber"
                  name="purchaseOrderReceiptNumber"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderReceiptNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PurchaseReceiptNumber StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderReceiptNumberStartsWith"
                  name="purchaseOrderReceiptNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderReceiptNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PurchaseReceiptNumber Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderReceiptNumberContains"
                  name="purchaseOrderReceiptNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderReceiptNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.vendorCodeOnChange}
                  value={searchCriteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>PurchaseOrder#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="purchaseOrderNumber"
                  name="purchaseOrderNumber"
                  onChange={this.onPurchaseOrderChange}
                  value={searchCriteria.purchaseOrderNumber}
                  lookupRequired={true}
                  lookupHandler={this.state.purchaseLookupHandler}
                  enterKeyEventHandler={this.purchaseOrderEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.purchaseOrderPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePurchaseOrderList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletePurchaseOrderList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  value={searchCriteria.fabricStyleCode}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col sm={5}>
                <FormLabel>Color</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="fabricStyleColorCode"
                  name="fabricStyleColorCode"
                  value={searchCriteria.fabricStyleColorCode}
                  onChange={this.onChange}
                  lookupRequired={this.state.isShowColorLookup}
                  lookupHandler={this.state.colorLookupHandler}
                  disabled={!this.state.isShowColorLookup}
                />
              </Col>
            </Row> */}
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="receiptStatus"
                  value={searchCriteria.receiptStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <FormLabel>Receipt Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="receiptDateFrom"
                  name="receiptDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.receiptDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="receiptDateTo"
                  name="receiptDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.receiptDateTo}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
